export default __webpack_public_path__ + "static/media/registration-success.b84af2a8.svg";